import React from 'react';
import {ValidatorComponent} from 'react-material-ui-form-validator';
import {Box, withStyles} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {styles} from './styles';

/**
 * class to render autocomplete validator with multiple selection
 * @returns {JSX.Element}
 */
class AutocompleteValidator extends ValidatorComponent {
  renderValidatorComponent() {
    const {
      multiple,
      value,
      label,
      errorMessages,
      validators,
      validatorListener,
      ...rest
    } = this.props;

    return (
      <Box>
        <Autocomplete multiple {...rest} />
        {this.errorText()}
      </Box>
    );
  }

  errorText() {
    const {isValid} = this.state;
    const {classes} = this.props;

    if (isValid) {
      return null;
    }

    return <Box className={classes.text}>{this.getErrorMessage()}</Box>;
  }
}

export default withStyles(styles)(AutocompleteValidator);
